import * as watchers from './performance-watchers'
import { fork } from 'redux-saga/effects'

export default [
  fork(watchers.watchPerformancePage),
  fork(watchers.watchPollPerformancePage),
  fork(watchers.watchAcknowledgePerformance),
  fork(watchers.watchDraftDealsSave),
  fork(watchers.watchEntitiesDealsSuccess),
  fork(watchers.watchDraftDealsCancel),
]



/** WEBPACK FOOTER **
 ** ./src/sagas/performance/index.js
 **/